import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';

@Component({
  selector: 'show-resource',
  templateUrl: './show-resource.component.html',
  styleUrls: ['./show-resource.component.scss']
})
export class ShowResourceComponent implements OnInit {
  resourceObservable: FirebaseObjectObservable<any>;
  resource: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService
  ) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.resourceObservable = this.dbService.getResource(params['key']);
      this.resourceObservable.subscribe(resource => {
        this.resource = resource;
      });
    });
  }

  onEditClicked() {
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked() {
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onConfirmDeletePost() {
    this.onHideDeleteModal()
    this.dbService.deleteResource(this.resource.$key, this.resource.fileKey);
    this.router.navigate([`/resources`]);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/show-resource/show-resource.component.ts